<template>
	<div class="container">
    <div class="head">临安区海内外高层次人才创新创业项目申报系统</div>
    <div class="table-box">

      <div style="margin-bottom: 10px">
        <el-button icon="el-icon-plus" type="info" style="background-color: #4873d3" @click="toApply">新增申报</el-button>
      </div>
      <xc-base-table
        ref="basicTable"
        :tableColumns="tableColumns"
        :searchParams="searchParams"
        :asyncFunc="fetchListFunc"
        :listName="listName"
        :hideStripe="true"
      >
        <template slot="talentType" slot-scope="{ row }">
          <span>{{getTalentType(row.talentType)}}</span>
        </template>

        <template slot="socialSecurityType" slot-scope="{ row }">
          <span>{{getSocialSecurityType(row.socialSecurityType).label}}</span>
        </template>

        <template slot="highestEducation" slot-scope="{ row }">
          <span>{{getHighestEducation(row.highestEducation).label}}</span>
        </template>

        <template slot="houseType" slot-scope="{ row }">
          <span>{{getHouseType(row.houseType).label}}</span>
        </template>

        <template slot="status" slot-scope="{ row }">
          <el-tag :type="getApplyStatus(row.status).tagType">{{getApplyStatus(row.status).value}}</el-tag>
        </template>

        <template slot="operation" slot-scope="{row}">
          <el-button size="mini" type="text" @click="toDetail(row)" v-if="row.status != APPLY_STATUS.TEMP_STORAGE.key">详情</el-button>
          <el-button size="mini" type="text" @click="toEdit(row)" v-if="row.status == APPLY_STATUS.TEMP_STORAGE.key || row.status == APPLY_STATUS.TURNDOWN.key">编辑</el-button>

        </template>

      </xc-base-table>
    </div>
	</div>
</template>

<script>
	import { applyList } from '@/api/HttpRequestAPI';
  import {toast, isMobile} from '@/utils'
  import {setLoginToken} from '@/cache/Cache'
  import {findByKey, APPLY_STATUS} from '@/constant/Enums'
	export default {
		name: 'apply-list',
		data() {
			return {
        APPLY_STATUS,
        searchParams:{},
        tableColumns: [
          { key: 'commissionName', title: '所属平台', width:110 },
          { key: 'name', title: '姓名', width:80 },
          { key: 'projectName', title: '项目名称'},
          { key: 'ly', title: '所属领域', width:110 },
          { key: 'phone', title: '联系电话', width:180 },
          { key: 'email', title: '邮箱', width:180 },
          { key: 'lxdz', title: '联系地址' },
          { key: 'status', title: '审核结果', type: 'slot', width:85 },
          { key: 'reason', title: '退回/资质不符原因', width:180 },
          { key: 'reportDate', title: '申报日期', width:150 },
          { key:'operation', title:'操作', type:'slot', fixed:'right', width:90},
        ],
        fetchListFunc: applyList,
        listName: 'reportList',
			};
		},
    mounted() {
      this.queryList()
    },
    methods: {
      queryList() {
        this.$refs.basicTable.fetchData()
      },
      toApply(){
        this.$router.push('/apply');
      },
      toDetail(row){
        this.$router.push({
          path:'/apply-detail',
          query:{
            id:row.id
          }
        });
      },
      toEdit(row){
        this.$router.push({
          path:'/apply',
          query:{
            id:row.id
          }
        });
      },
      getApplyStatus(status){
        return findByKey(APPLY_STATUS, status)
      }

		},
	};
</script>

<style lang="less" scoped>
	@import url(./index.less);
</style>
